export const types = {
  UPDATE_NOC_FORM_FIELD: "UPDATE_NOC_FORM_FIELD",
  UPDATE_NOC_FORM_DATA: "UPDATE_NOC_FORM_DATA",
  UPDATE_OTHERS_DETAILS: "UPDATE_NOC_OTHERS_DETAILS",
  UPDATE_APPLICANT_OTHERS_DETAILS: "UPDATE_APPLICANT_NOC_OTHERS_DETAILS",
};

export const updateFormData = (name, value) => ({
  type: types.UPDATE_NOC_FORM_FIELD,
  payload: { name, value },
});

export const updateBulkFormData = (formData) => ({
  type: types.UPDATE_NOC_FORM_DATA,
  payload: formData,
});
export const updateNocDetailsData = (details) => ({
  type: types.UPDATE_OTHERS_DETAILS,
  payload: details,
});
export const updateApplicantNocDetailsData = (details) => ({
  type: types.UPDATE_APPLICANT_OTHERS_DETAILS,
  payload: details,
});
